
/**
 * 강의 콘텐츠 지원 플랫폼
 */
export type CourseDetailLecturePlatformSupport = typeof CourseDetailLecturePlatformSupport[keyof typeof CourseDetailLecturePlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDetailLecturePlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
  UNKNOWN: 'UNKNOWN',
} as const;
